import h from 'hyperscript'
import data from '../data/education.yaml'

const id = document.getElementById.bind(document)
const params = new URLSearchParams(location.search)
const q = parseInt(params.get('q'))
const r = parseInt(params.get('r'))
const page = !isNaN(q) && !isNaN(r)

id('app').appendChild(
  page ?
    h('.section',
      h('.container',
        h('.columns',
          h('.column',
            h('.content.is-family-secondary',
              h('h1', data[q].list[r].title),
              h('p', data[q].list[r].text),
              h('ul',
                data[q].list[r].list.map(value =>
                  h('li', value)
                )
              )
            )
          ),
          h('.column#form-parent')
        )
      )
    )
    :
    h('div',
      h('.section',
        h('.container',
          h('.title.has-text-centered', 'Eğitimler'))),
      data.map((value, indexQ) =>
        h('.section',
          h('.container',
            h('.title.is-4', value.title),
            h('.columns.is-multiline',
              value.list.map((value, indexR) =>
                h('.column.is-one-third.is-flex',
                  h('a.box.is-family-secondary', {
                    href: `?q=${indexQ}&r=${indexR}&z=${value.title}`
                  },
                    h('.title.is-5', value.title),
                    h('.subtitle.is-6',
                      value.text.split(/^(.{100}\S*)/)[1] + '\u2026'
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
)

if (page) {
  id('form-parent').appendChild(id('form'))
  id('form').classList.remove('is-hidden')
  id('request').value = data[q].list[r].title
}
